import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n.ts';
import { initSafeArea } from './lib/initSafeArea.ts';

void initSafeArea().finally(() => {
  createRoot(document.getElementById('root')!).render(<App />);
});
